import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedManhwa from './components/FeaturedManhwa';
import CategoryGrid from './components/CategoryGrid';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';
import { featuredManhwa, latestUpdates, faqItems } from '@/mocks/manhwa';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main>
        <HeroSection />
        <FeaturedManhwa manhwaList={featuredManhwa} />
        <CategoryGrid />
        <LatestUpdates manhwaList={latestUpdates} />
        <FAQSection faqItems={faqItems} />
      </main>

      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '虚空韩漫网 — 韩漫在线阅读',
            description:
              '虚空韩漫网提供顺畅的韩漫在线阅读体验，聚合了韩国漫画网免费在线观看的韩国漫画，资源整合能力强。',
            url: 'https://www.xkmanhua.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '虚空韩漫网',
              url: 'https://www.xkmanhua.com/',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'https://www.xkmanhua.com/',
                },
              ],
            },
          }),
        }}
      />
    </>
  );
}